// @generated by protoc-gen-es v1.7.2
// @generated from file proctoring/v1/incidents.proto (package proctoring.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Session_Key, SessionInfo_Severity } from "./session_pb.js";

/**
 * @generated from message proctoring.v1.IncidentServiceGetRequest
 */
export const IncidentServiceGetRequest = proto3.makeMessageType(
  "proctoring.v1.IncidentServiceGetRequest",
  () => [
    { no: 1, name: "session_key", kind: "message", T: Session_Key },
  ],
);

/**
 * @generated from message proctoring.v1.IncidentServiceGetResponse
 */
export const IncidentServiceGetResponse = proto3.makeMessageType(
  "proctoring.v1.IncidentServiceGetResponse",
  () => [
    { no: 1, name: "incident", kind: "message", T: Incident },
    { no: 2, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "severity", kind: "enum", T: proto3.getEnumType(SessionInfo_Severity) },
  ],
);

/**
 * @generated from message proctoring.v1.IncidentServiceOverrideSeverityRequest
 */
export const IncidentServiceOverrideSeverityRequest = proto3.makeMessageType(
  "proctoring.v1.IncidentServiceOverrideSeverityRequest",
  () => [
    { no: 1, name: "incident_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "severity", kind: "enum", T: proto3.getEnumType(SessionInfo_Severity) },
  ],
);

/**
 * @generated from message proctoring.v1.IncidentServiceOverrideSeverityResponse
 */
export const IncidentServiceOverrideSeverityResponse = proto3.makeMessageType(
  "proctoring.v1.IncidentServiceOverrideSeverityResponse",
  [],
);

/**
 * @generated from message proctoring.v1.IncidentServiceUpdateConfigurationRequest
 */
export const IncidentServiceUpdateConfigurationRequest = proto3.makeMessageType(
  "proctoring.v1.IncidentServiceUpdateConfigurationRequest",
  () => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "config", kind: "message", T: IncidentConfiguration },
  ],
);

/**
 * @generated from message proctoring.v1.IncidentServiceUpdateConfigurationResponse
 */
export const IncidentServiceUpdateConfigurationResponse = proto3.makeMessageType(
  "proctoring.v1.IncidentServiceUpdateConfigurationResponse",
  [],
);

/**
 * @generated from message proctoring.v1.IncidentServiceGetConfigurationRequest
 */
export const IncidentServiceGetConfigurationRequest = proto3.makeMessageType(
  "proctoring.v1.IncidentServiceGetConfigurationRequest",
  () => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message proctoring.v1.IncidentServiceGetConfigurationResponse
 */
export const IncidentServiceGetConfigurationResponse = proto3.makeMessageType(
  "proctoring.v1.IncidentServiceGetConfigurationResponse",
  () => [
    { no: 2, name: "config", kind: "message", T: IncidentConfiguration },
  ],
);

/**
 * @generated from message proctoring.v1.Incident
 */
export const Incident = proto3.makeMessageType(
  "proctoring.v1.Incident",
  () => [
    { no: 1, name: "time", kind: "message", T: Timestamp },
    { no: 2, name: "assessment_start", kind: "message", T: Incident_AssessmentStart, oneof: "incident" },
    { no: 3, name: "assessment_end", kind: "message", T: Incident_AssessmentEnd, oneof: "incident" },
    { no: 4, name: "clipboard_copy", kind: "message", T: Incident_ClipboardCopy, oneof: "incident" },
    { no: 5, name: "clipboard_cut", kind: "message", T: Incident_ClipboardCut, oneof: "incident" },
    { no: 6, name: "clipboard_paste", kind: "message", T: Incident_ClipboardPaste, oneof: "incident" },
    { no: 13, name: "screenshot", kind: "message", T: Incident_Screenshot, oneof: "incident" },
    { no: 14, name: "extra_displays", kind: "message", T: Incident_ExtraDisplays, oneof: "incident" },
    { no: 19, name: "display_recording_started", kind: "message", T: Incident_DisplayRecordingStarted, oneof: "incident" },
    { no: 15, name: "display_recording_stopped", kind: "message", T: Incident_DisplayRecordingStopped, oneof: "incident" },
    { no: 20, name: "user_media_recording_started", kind: "message", T: Incident_UserMediaRecordingStarted, oneof: "incident" },
    { no: 16, name: "user_media_recording_stopped", kind: "message", T: Incident_UserMediaRecordingStopped, oneof: "incident" },
    { no: 12, name: "connection_lost", kind: "message", T: Incident_ConnectionLost, oneof: "incident" },
    { no: 17, name: "microphone_audio_loud", kind: "message", T: Incident_MicrophoneAudioLoud, oneof: "incident" },
    { no: 7, name: "phone_present", kind: "message", T: Incident_PhonePresent, oneof: "incident" },
    { no: 8, name: "computer_present", kind: "message", T: Incident_ComputerPresent, oneof: "incident" },
    { no: 9, name: "book_present", kind: "message", T: Incident_BookPresent, oneof: "incident" },
    { no: 10, name: "target_person_missing", kind: "message", T: Incident_TargetPersonMissing, oneof: "incident" },
    { no: 11, name: "other_people_present", kind: "message", T: Incident_OtherPeoplePresent, oneof: "incident" },
  ],
);

/**
 * @generated from message proctoring.v1.Incident.AssessmentStart
 */
export const Incident_AssessmentStart = proto3.makeMessageType(
  "proctoring.v1.Incident.AssessmentStart",
  [],
  {localName: "Incident_AssessmentStart"},
);

/**
 * @generated from message proctoring.v1.Incident.AssessmentEnd
 */
export const Incident_AssessmentEnd = proto3.makeMessageType(
  "proctoring.v1.Incident.AssessmentEnd",
  [],
  {localName: "Incident_AssessmentEnd"},
);

/**
 * @generated from message proctoring.v1.Incident.ClipboardCopy
 */
export const Incident_ClipboardCopy = proto3.makeMessageType(
  "proctoring.v1.Incident.ClipboardCopy",
  [],
  {localName: "Incident_ClipboardCopy"},
);

/**
 * @generated from message proctoring.v1.Incident.ClipboardCut
 */
export const Incident_ClipboardCut = proto3.makeMessageType(
  "proctoring.v1.Incident.ClipboardCut",
  [],
  {localName: "Incident_ClipboardCut"},
);

/**
 * @generated from message proctoring.v1.Incident.ClipboardPaste
 */
export const Incident_ClipboardPaste = proto3.makeMessageType(
  "proctoring.v1.Incident.ClipboardPaste",
  [],
  {localName: "Incident_ClipboardPaste"},
);

/**
 * @generated from message proctoring.v1.Incident.Screenshot
 */
export const Incident_Screenshot = proto3.makeMessageType(
  "proctoring.v1.Incident.Screenshot",
  [],
  {localName: "Incident_Screenshot"},
);

/**
 * @generated from message proctoring.v1.Incident.ExtraDisplays
 */
export const Incident_ExtraDisplays = proto3.makeMessageType(
  "proctoring.v1.Incident.ExtraDisplays",
  [],
  {localName: "Incident_ExtraDisplays"},
);

/**
 * @generated from message proctoring.v1.Incident.DisplayRecordingStarted
 */
export const Incident_DisplayRecordingStarted = proto3.makeMessageType(
  "proctoring.v1.Incident.DisplayRecordingStarted",
  [],
  {localName: "Incident_DisplayRecordingStarted"},
);

/**
 * @generated from message proctoring.v1.Incident.DisplayRecordingStopped
 */
export const Incident_DisplayRecordingStopped = proto3.makeMessageType(
  "proctoring.v1.Incident.DisplayRecordingStopped",
  [],
  {localName: "Incident_DisplayRecordingStopped"},
);

/**
 * @generated from message proctoring.v1.Incident.UserMediaRecordingStarted
 */
export const Incident_UserMediaRecordingStarted = proto3.makeMessageType(
  "proctoring.v1.Incident.UserMediaRecordingStarted",
  [],
  {localName: "Incident_UserMediaRecordingStarted"},
);

/**
 * @generated from message proctoring.v1.Incident.UserMediaRecordingStopped
 */
export const Incident_UserMediaRecordingStopped = proto3.makeMessageType(
  "proctoring.v1.Incident.UserMediaRecordingStopped",
  [],
  {localName: "Incident_UserMediaRecordingStopped"},
);

/**
 * @generated from message proctoring.v1.Incident.ConnectionLost
 */
export const Incident_ConnectionLost = proto3.makeMessageType(
  "proctoring.v1.Incident.ConnectionLost",
  [],
  {localName: "Incident_ConnectionLost"},
);

/**
 * @generated from message proctoring.v1.Incident.MicrophoneAudioLoud
 */
export const Incident_MicrophoneAudioLoud = proto3.makeMessageType(
  "proctoring.v1.Incident.MicrophoneAudioLoud",
  [],
  {localName: "Incident_MicrophoneAudioLoud"},
);

/**
 * @generated from message proctoring.v1.Incident.PhonePresent
 */
export const Incident_PhonePresent = proto3.makeMessageType(
  "proctoring.v1.Incident.PhonePresent",
  () => [
    { no: 1, name: "confidence", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ],
  {localName: "Incident_PhonePresent"},
);

/**
 * @generated from message proctoring.v1.Incident.ComputerPresent
 */
export const Incident_ComputerPresent = proto3.makeMessageType(
  "proctoring.v1.Incident.ComputerPresent",
  () => [
    { no: 1, name: "confidence", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ],
  {localName: "Incident_ComputerPresent"},
);

/**
 * @generated from message proctoring.v1.Incident.BookPresent
 */
export const Incident_BookPresent = proto3.makeMessageType(
  "proctoring.v1.Incident.BookPresent",
  () => [
    { no: 1, name: "confidence", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ],
  {localName: "Incident_BookPresent"},
);

/**
 * @generated from message proctoring.v1.Incident.TargetPersonMissing
 */
export const Incident_TargetPersonMissing = proto3.makeMessageType(
  "proctoring.v1.Incident.TargetPersonMissing",
  () => [
    { no: 1, name: "confidence", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ],
  {localName: "Incident_TargetPersonMissing"},
);

/**
 * @generated from message proctoring.v1.Incident.OtherPeoplePresent
 */
export const Incident_OtherPeoplePresent = proto3.makeMessageType(
  "proctoring.v1.Incident.OtherPeoplePresent",
  () => [
    { no: 1, name: "confidence", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ],
  {localName: "Incident_OtherPeoplePresent"},
);

/**
 * @generated from message proctoring.v1.IncidentConfiguration
 */
export const IncidentConfiguration = proto3.makeMessageType(
  "proctoring.v1.IncidentConfiguration",
  () => [
    { no: 1, name: "v1", kind: "message", T: IncidentConfiguration_V1, oneof: "config" },
  ],
);

/**
 * @generated from message proctoring.v1.IncidentConfiguration.V1
 */
export const IncidentConfiguration_V1 = proto3.makeMessageType(
  "proctoring.v1.IncidentConfiguration.V1",
  () => [
    { no: 2, name: "assessment_start", kind: "message", T: IncidentConfiguration_V1_SimpleSeverityCheck },
    { no: 3, name: "assessment_end", kind: "message", T: IncidentConfiguration_V1_SimpleSeverityCheck },
    { no: 4, name: "clipboard_copy", kind: "message", T: IncidentConfiguration_V1_SimpleSeverityCheck },
    { no: 5, name: "clipboard_cut", kind: "message", T: IncidentConfiguration_V1_SimpleSeverityCheck },
    { no: 6, name: "clipboard_paste", kind: "message", T: IncidentConfiguration_V1_SimpleSeverityCheck },
    { no: 13, name: "screenshot", kind: "message", T: IncidentConfiguration_V1_SimpleSeverityCheck },
    { no: 14, name: "extra_displays", kind: "message", T: IncidentConfiguration_V1_SimpleSeverityCheck },
    { no: 19, name: "display_recording_started", kind: "message", T: IncidentConfiguration_V1_SimpleSeverityCheck },
    { no: 15, name: "display_recording_stopped", kind: "message", T: IncidentConfiguration_V1_SimpleSeverityCheck },
    { no: 20, name: "user_media_recording_started", kind: "message", T: IncidentConfiguration_V1_SimpleSeverityCheck },
    { no: 16, name: "user_media_recording_stopped", kind: "message", T: IncidentConfiguration_V1_SimpleSeverityCheck },
    { no: 12, name: "connection_lost", kind: "message", T: IncidentConfiguration_V1_SimpleSeverityCheck },
    { no: 17, name: "microphone_audio_loud", kind: "message", T: IncidentConfiguration_V1_SimpleSeverityCheck },
    { no: 7, name: "phone_present", kind: "message", T: IncidentConfiguration_V1_ConfidenceSeverityCheck },
    { no: 8, name: "computer_present", kind: "message", T: IncidentConfiguration_V1_ConfidenceSeverityCheck },
    { no: 9, name: "book_present", kind: "message", T: IncidentConfiguration_V1_ConfidenceSeverityCheck },
    { no: 10, name: "target_person_missing", kind: "message", T: IncidentConfiguration_V1_ConfidenceSeverityCheck },
    { no: 11, name: "other_people_present", kind: "message", T: IncidentConfiguration_V1_ConfidenceSeverityCheck },
  ],
  {localName: "IncidentConfiguration_V1"},
);

/**
 * @generated from message proctoring.v1.IncidentConfiguration.V1.SimpleSeverityCheck
 */
export const IncidentConfiguration_V1_SimpleSeverityCheck = proto3.makeMessageType(
  "proctoring.v1.IncidentConfiguration.V1.SimpleSeverityCheck",
  () => [
    { no: 1, name: "severity", kind: "enum", T: proto3.getEnumType(SessionInfo_Severity) },
  ],
  {localName: "IncidentConfiguration_V1_SimpleSeverityCheck"},
);

/**
 * @generated from message proctoring.v1.IncidentConfiguration.V1.ConfidenceSeverityCheck
 */
export const IncidentConfiguration_V1_ConfidenceSeverityCheck = proto3.makeMessageType(
  "proctoring.v1.IncidentConfiguration.V1.ConfidenceSeverityCheck",
  () => [
    { no: 1, name: "minimum_confidence", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "severity", kind: "enum", T: proto3.getEnumType(SessionInfo_Severity) },
  ],
  {localName: "IncidentConfiguration_V1_ConfidenceSeverityCheck"},
);

